export enum MetabaseDashboardIds {
  Fifth = 5,
  Seventh = 7,
}
